module.exports = __webpack_public_path__ + "img/QK.a9525387.png";